import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CustomInput, Inline, Modal, NoResult, Text } from '../../..';
import { withMediaQueries } from '../../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../../style';
import { MODAL_CLOSE } from '../../../../../app/redux/actions';
import Pagination from '../../../Pagination';
import SortBy from '../../../SortBy';
import { FiltersWrapper, Legend, SortingWrapper, CategoryCard } from './style';
import { getSortingOptions } from '../../../../../utils/labels';
import TimeIntervalFilter from '../../../TimeIntervalFilter';
import { CATEGORY_LIST_GET } from '../../../../../app/redux/actions/supervisorStats';
import { timestampToDate } from '../../../../../utils/common';

export const ModalSupervisorCategoriesId = 'ModalSupervisorCategories';

const ModalSupervisorCategories = ({
  mediaIsPhone,
  count_category,
  list,
  pager,
  getCategoryList,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    getCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetCategoryList = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      page,
    };
    getCategoryList(parsedFilters);
  };

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) handleGetCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetCategoryList(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <Modal
      title="Lista aree tematiche"
      description="Sezione dedicata a tutti le aree tematiche presenti sulla piattaforma."
      modalId={ModalSupervisorCategoriesId}
      scrollableAreaRef={scrollableAreaRef}
      mbTitle={16}
    >
      <FiltersWrapper>
        <CustomInput
          size={540}
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(v) => setSearchValue(v)}
          onClickIcon={onClickSearch}
          onKeyPress={(event) => {
            if (event.key === 'Enter') onClickSearch();
          }}
        />
        <TimeIntervalFilter
          callback={(start_date, end_date) => {
            setSelectedFilters({
              ...selectedFilters,
              start_date,
              end_date,
            });
          }}
        />
      </FiltersWrapper>
      <SortingWrapper>
        <Text type="b3">{count_category || 0} aree tematiche</Text>
        <SortBy
          options={getSortingOptions([
            'last_update_asc',
            'last_update_desc',
            'alphabetical_asc',
            'alphabetical_desc',
          ])}
          onChange={(v) => {
            setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
          }}
        />
      </SortingWrapper>
      <Legend>
        <Text type="statistics-heading">Area tematica</Text>
        <Text type="statistics-heading">N. percorsi formativi</Text>
        <Text type="statistics-heading">Corsi</Text>
        <Text type="statistics-heading">Eventi</Text>
        {/* //? "Data di creazione" is ko */}
        <Text type="statistics-heading">Ultima modifica</Text>
      </Legend>
      <ScrollableArea ref={scrollableAreaRef} preserveShadows>
        {list?.length > 0 ? (
          (list || []).map((category, ci) => (
            <CategoryCard key={`category-${ci}`}>
              <Text type="h3" className="ellipsis">
                {category?.category_name}
              </Text>
              <Text type="b2">
                {Number(category?.course_count || 0) +
                  Number(category?.event_count || 0)}
              </Text>
              <Inline alignItems="baseline">
                <Text type="b2">{category?.course_count || 0}</Text>
                <Text type="b4">
                  /
                  {Number(category?.course_count || 0) +
                    Number(category?.event_count || 0)}
                </Text>
              </Inline>
              <Inline alignItems="baseline">
                <Text type="b2">{category?.event_count || 0}</Text>
                <Text type="b4">
                  /
                  {Number(category?.course_count || 0) +
                    Number(category?.event_count || 0)}
                </Text>
              </Inline>
              <Text type="b4">
                {timestampToDate(category?.last_changed, 'DD/MM/YYYY HH:mm')}
              </Text>
            </CategoryCard>
          ))
        ) : (
          <NoResult />
        )}
      </ScrollableArea>
      <Footer pt={40} pb={48}>
        <Pagination
          pb={0}
          pager={pager}
          callBack={loadMore}
          setItemsPerPage={setItemsPerPage}
        />
      </Footer>
    </Modal>
  );
};

ModalSupervisorCategories.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  count_category: PropTypes.number,
  list: PropTypes.array,
  pager: PropTypes.object,
  // dispatch
  getCategoryList: PropTypes.func.isRequired,
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { count_category, list, pager } =
        state.supervisorStats.lists.categories;
      return { count_category, list, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getCategoryList: (filters) =>
        dispatch({ type: CATEGORY_LIST_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalSupervisorCategories);
